export const allowedOrigins = [
	'https://qsuite.nuqlea.com',
	'https://qsuite-dev.nuqlea.com',
	'https://qsuite-demo.nuqlea.com',
	'https://backoffice.nuqlea.com',
	'https://backoffice-dev.nuqlea.com',
	'https://backoffice-demo.nuqlea.com',
	'https://studio-dev.nuqlea.com',
	'https://studio.nuqlea.com',
	'http://localhost:3000',
	'http://localhost:3001',
	'http://localhost:5001',
];
